/* Garage Rewards — storefront client. Talks directly to the Supabase Edge Functions
   (CORS-enabled): email magic-link auth via Supabase Auth, then GET /member and POST /redeem.
   Loaded on the rewards + garage templates (guards on #epp-rw-card). */
(function () {
  "use strict";
  var CFG = window.EPP_REWARDS || {};
  if (!CFG.url || !CFG.anonKey || !CFG.fns) return;

  var LANG = (window.EPP_LOCALE && String(window.EPP_LOCALE).toLowerCase().indexOf("fr") === 0)
    ? "fr" : (localStorage.getItem("epp_lang") || "en");
  function T(en, fr) { return LANG === "fr" ? fr : en; }
  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  function loadSupabase(cb) {
    if (window.supabase && window.supabase.createClient) return cb();
    var s = document.createElement("script");
    s.src = "https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2";
    s.onload = cb;
    s.onerror = function () { console.warn("rewards: supabase-js failed to load"); };
    document.head.appendChild(s);
  }

  function hasStoredSession() {
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k && k.indexOf("sb-") === 0 && k.indexOf("-auth-token") > 0 && localStorage.getItem(k)) return true;
      }
    } catch (e) {}
    return false;
  }

  ready(function () {
    // rewards/garage pages always; every other page only for signed-in members (vehicle sync)
    if (!$("epp-rw-card") && !hasStoredSession()) return;

    // redeem — gated until checkout discount-creation exists (EPP_REWARDS.redeem).
    // Balance / tier / history / auth stay fully live; only spending is paused.
    // Runs before the supabase-js load so the buttons never show, even offline.
    if (!CFG.redeem) {
      document.querySelectorAll("#epp-rw-redeem [data-redeem]").forEach(function (b) {
        b.disabled = true;
        b.hidden = true;
        b.setAttribute("aria-hidden", "true");
      });
      var gateMsg = $("epp-rw-redeemmsg");
      if (gateMsg) {
        var noteEn = "Point redemption opens at launch — your points are safe.";
        var noteFr = "L'échange de points arrive au lancement — tes points sont en sécurité.";
        gateMsg.setAttribute("data-en", noteEn);
        gateMsg.setAttribute("data-fr", noteFr);
        gateMsg.textContent = T(noteEn, noteFr);
      }
    }

    loadSupabase(function () {
      var sb = window.supabase.createClient(CFG.url, CFG.anonKey, {
        auth: { persistSession: true, detectSessionInUrl: true, flowType: "pkce" }
      });
      // shared with epp-builds.js (Community Builds page + Garage "My Builds") so it reuses this session
      window.EPP_SB = sb;
      try { window.dispatchEvent(new CustomEvent("epp:sb", { detail: sb })); } catch (e) {}
      var authmsg = $("epp-rw-authmsg"), redeemmsg = $("epp-rw-redeemmsg");
      var nf = new Intl.NumberFormat(LANG === "fr" ? "fr-CA" : "en-CA");

      function showSignedIn(yes) {
        if ($("epp-rw-signedout")) $("epp-rw-signedout").hidden = yes;
        if ($("epp-rw-signedin")) $("epp-rw-signedin").hidden = !yes;
      }
      function money(cents) {
        var v = (cents / 100); v = (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2);
        return LANG === "fr" ? (v + " $") : ("$" + v); // FR: NBSP before $
      }
      var sessEmail = ""; // set on each session read; used by the Garage hub head

      function renderMember(d) {
        var m = d && d.member;
        if (!m) return;
        // Garage hub head + stats (present on the garage template only)
        var email = m.email || sessEmail;
        if ($("epp-rw-member-email")) $("epp-rw-member-email").textContent = email;
        if ($("epp-rw-avatar") && email) $("epp-rw-avatar").textContent = email.charAt(0).toUpperCase();
        if ($("epp-rw-stat-points")) $("epp-rw-stat-points").textContent = nf.format(m.balance || 0);
        // welcome offer: shown until the first earned order lands on the account
        var hasEarn = (d.transactions || []).some(function (t) { return t.kind === "earn"; });
        document.querySelectorAll("[data-gr-welcome]").forEach(function (el) { el.hidden = hasEarn; });
        if ($("epp-rw-balance")) $("epp-rw-balance").textContent = nf.format(m.balance || 0);
        if ($("epp-rw-value")) $("epp-rw-value").textContent = money(Math.floor((m.balance || 0) / 250) * 500); // floor to redeem step, like the backend
        if ($("epp-rw-tier")) $("epp-rw-tier").textContent = m.tier_name || m.tier_key || "Street";
        document.querySelectorAll(".tiercard").forEach(function (c) {
          c.classList.toggle("is-current", c.getAttribute("data-tier") === (m.tier_key || ""));
        });
        var h = $("epp-rw-history");
        if (h) {
          var tx = (d.transactions || []).slice(0, 8);
          h.innerHTML = tx.length ? tx.map(function (t) {
            var pos = (t.points || 0) > 0;
            return '<div style="display:flex;justify-content:space-between;gap:12px;padding:8px 0;border-bottom:1px solid var(--epp-border);font-size:.9rem">' +
              '<span>' + esc(t.reason || t.kind) + '</span>' +
              '<b style="color:' + (pos ? "#1a8f3c" : "var(--epp-text-muted)") + '">' + (pos ? "+" : "") + (t.points || 0) + '</b></div>';
          }).join("") : '<p class="muted" style="font-size:.9rem">' +
            T("No activity yet — earn points on your first order.", "Aucune activité pour l'instant — accumulez des points dès votre première commande.") + '</p>';
        }
      }

      // Garage hub: order history via the /orders edge function (no Shopify login needed)
      function renderOrders(list) {
        var box = $("epp-rw-orders");
        if (!box) return;
        if ($("epp-rw-stat-orders")) $("epp-rw-stat-orders").textContent = String(list.length);
        if (!list.length) {
          box.innerHTML = '<div class="gar-empty"><h3>' +
            T("No orders yet", "Aucune commande") + '</h3><p>' +
            T("Your Évolution Plus Performance orders will show up here.", "Tes commandes Évolution Plus Performance apparaîtront ici.") +
            '</p><a class="btn btn-red btn-sm" href="/collections/all">' + T("Shop parts →", "Magasiner →") + '</a></div>';
          return;
        }
        var df = new Intl.DateTimeFormat(LANG === "fr" ? "fr-CA" : "en-CA", { year: "numeric", month: "short", day: "numeric" });
        box.innerHTML = list.map(function (o) {
          var st, dot;
          if (o.cancelled) { st = T("Cancelled", "Annulée"); dot = "var(--epp-text-muted)"; }
          else if (String(o.financial_status || "").indexOf("refunded") >= 0) { st = T("Refunded", "Remboursée"); dot = "var(--epp-text-muted)"; }
          else if (o.fulfillment_status === "fulfilled") { st = T("Shipped", "Expédiée"); dot = "#1a8f3c"; }
          else { st = T("Processing", "En traitement"); dot = "var(--epp-red)"; }
          var total = parseFloat(o.total_price || "0");
          var totalTxt; try {
            totalTxt = new Intl.NumberFormat(LANG === "fr" ? "fr-CA" : "en-CA", { style: "currency", currency: o.currency || "CAD" }).format(total);
          } catch (e) { totalTxt = (o.currency || "CAD") + " " + total.toFixed(2); }
          var items = (o.item_count || 0) + " " + (o.item_count === 1 ? T("item", "article") : T("items", "articles"));
          return '<div class="wal-row">' +
            '<div class="info"><div class="t"><b>' + esc(o.name) + '</b>' +
            '<span class="badge"><span class="dot" style="background:' + dot + '"></span>' + st + '</span></div>' +
            '<div class="s">' + esc(df.format(new Date(o.created_at))) + ' · ' + items + ' · ' + esc(totalTxt) + '</div></div>' +
            (o.status_url ? '<div class="acts"><a class="btn btn-ghost btn-sm" href="' + esc(o.status_url) + '" target="_blank" rel="noopener">' +
              T("Track →", "Suivre →") + '</a></div>' : "") +
            '</div>';
        }).join("");
      }
      function loadOrders(sess) {
        if (!$("epp-rw-orders")) return; // garage template only
        fetch(CFG.fns + "/orders", { headers: { "Authorization": "Bearer " + sess.access_token, "apikey": CFG.anonKey } })
          .then(function (res) { return res.json(); })
          .then(function (d) { renderOrders((d && d.orders) || []); })
          .catch(function () { /* leave the loading note */ });
      }

      function loadMember() {
        sb.auth.getSession().then(function (r) {
          var sess = r.data && r.data.session;
          if (!sess) { showSignedIn(false); return; }
          sessEmail = (sess.user && sess.user.email) || "";
          showSignedIn(true); // reflect auth state immediately; data fills in next
          fetch(CFG.fns + "/member", { headers: { "Authorization": "Bearer " + sess.access_token, "apikey": CFG.anonKey } })
            .then(function (res) { return res.json(); })
            .then(function (d) { if (d && d.member) renderMember(d); })
            .catch(function () { /* keep signed-in shell */ });
          loadOrders(sess);
        });
      }

      // sign-in — emails a 6-digit code (no URL in the email), verified right here
      var form = $("epp-rw-loginform");
      if (form) form.addEventListener("submit", function (e) {
        e.preventDefault();
        var email = (($("epp-rw-email") || {}).value || "").trim();
        if (!email) return;
        if (authmsg) authmsg.textContent = T("Sending…", "Envoi…");
        sb.auth.signInWithOtp({ email: email })
          .then(function (r) {
            if (r.error) {
              if (authmsg) authmsg.textContent = T("Couldn't send the code: ", "Échec de l'envoi : ") + r.error.message;
              return;
            }
            var wrap = $("epp-rw-codewrap");
            if (wrap) { wrap.hidden = false; var ci = $("epp-rw-code"); if (ci) { ci.value = ""; ci.focus(); } }
            if (authmsg) authmsg.textContent = T("We emailed you a 6-digit code — enter it here.", "On t'a envoyé un code à 6 chiffres par courriel — entre-le ici.");
          });
      });

      // code verification (verifyOtp type 'email' covers sign-in AND first-time signup)
      var vBtn = $("epp-rw-verify");
      if (vBtn) vBtn.addEventListener("click", function () {
        var email = (($("epp-rw-email") || {}).value || "").trim();
        var code = (($("epp-rw-code") || {}).value || "").replace(/\D/g, "");
        if (!email) { if (authmsg) authmsg.textContent = T("Enter your email first.", "Entre d'abord ton courriel."); return; }
        if (code.length < 6) { if (authmsg) authmsg.textContent = T("Enter the full code from the email.", "Entre le code complet reçu par courriel."); return; }
        vBtn.disabled = true;
        if (authmsg) authmsg.textContent = T("Verifying…", "Vérification…");
        sb.auth.verifyOtp({ email: email, token: code, type: "email" })
          .then(function (r) {
            vBtn.disabled = false;
            if (r.error) {
              if (authmsg) authmsg.textContent = T("Wrong or expired code — request a new one.", "Code invalide ou expiré — demande-en un nouveau.");
              return;
            }
            var wrap = $("epp-rw-codewrap");
            if (wrap) wrap.hidden = true;
            if (authmsg) authmsg.textContent = "";
            loadMember();
          });
      });
      var codeInput = $("epp-rw-code");
      if (codeInput) codeInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") { e.preventDefault(); if (vBtn) vBtn.click(); }
      });

      var so = $("epp-rw-signout");
      if (so) so.addEventListener("click", function () { sb.auth.signOut().then(function () { showSignedIn(false); }); });

      // social login — gated by EPP_REWARDS flags; buttons light up once the provider is enabled in Supabase
      function wireSocial(flag, btnId, provider, labelEn, labelFr) {
        if (!flag) return;
        if ($("epp-rw-social")) $("epp-rw-social").hidden = false;
        var b = $(btnId);
        if (b) { b.hidden = false; b.addEventListener("click", function () {
          sb.auth.signInWithOAuth({ provider: provider, options: { redirectTo: location.href.split("#")[0] } })
            .then(function (r) { if (r && r.error && authmsg) authmsg.textContent = T(labelEn + " sign-in unavailable: ", "Connexion " + labelFr + " indisponible : ") + r.error.message; });
        }); }
      }
      wireSocial(CFG.google, "epp-rw-google", "google", "Google", "Google");
      wireSocial(CFG.facebook, "epp-rw-facebook", "facebook", "Facebook", "Facebook");

      // redeem wiring (skipped while EPP_REWARDS.redeem is off — see gate above)
      if (CFG.redeem) {
      document.querySelectorAll("#epp-rw-redeem [data-redeem]").forEach(function (b) {
        b.addEventListener("click", function () {
          var pts = parseInt(b.getAttribute("data-redeem"), 10);
          sb.auth.getSession().then(function (r) {
            var sess = r.data && r.data.session;
            if (!sess) { if (redeemmsg) redeemmsg.textContent = T("Sign in first to redeem.", "Connectez-vous d'abord pour échanger."); return; }
            if (redeemmsg) redeemmsg.textContent = T("Redeeming…", "Échange en cours…");
            fetch(CFG.fns + "/redeem", {
              method: "POST",
              headers: { "Authorization": "Bearer " + sess.access_token, "apikey": CFG.anonKey, "Content-Type": "application/json" },
              body: JSON.stringify({ points: pts, store_slug: "evolution-plus-performance" })
            }).then(function (res) { return res.json(); }).then(function (d) {
              if (!redeemmsg) return;
              if (d.error) { redeemmsg.textContent = T("Couldn't redeem: ", "Échec : ") + d.error; return; }
              redeemmsg.innerHTML = T("Done! Your store-credit code: ", "C'est fait ! Votre code de crédit : ") + '<b>' + esc(d.redemption && d.redemption.code) + '</b>';
              loadMember();
            }).catch(function () { if (redeemmsg) redeemmsg.textContent = T("Something went wrong.", "Une erreur est survenue."); });
          });
        });
      });
      }

      // account deletion (right to erasure — Law 25 / PIPEDA)
      var dBtn = $("epp-rw-delete"), dConfirm = $("epp-rw-delete-confirm"), dGo = $("epp-rw-delete-go"), dCancel = $("epp-rw-delete-cancel"), dMsg = $("epp-rw-delete-msg");
      if (dBtn && dConfirm) {
        dBtn.addEventListener("click", function () { dConfirm.hidden = false; dBtn.hidden = true; });
        if (dCancel) dCancel.addEventListener("click", function () { dConfirm.hidden = true; dBtn.hidden = false; if (dMsg) dMsg.textContent = ""; });
        if (dGo) dGo.addEventListener("click", function () {
          sb.auth.getSession().then(function (r) {
            var sess = r.data && r.data.session;
            if (!sess) { if (dMsg) dMsg.textContent = T("Please sign in again.", "Veuillez vous reconnecter."); return; }
            if (dMsg) dMsg.textContent = T("Deleting…", "Suppression…"); dGo.disabled = true;
            fetch(CFG.fns + "/delete-account", { method: "POST", headers: { "Authorization": "Bearer " + sess.access_token, "apikey": CFG.anonKey } })
              .then(function (res) { return res.json(); })
              .then(function (d) {
                if (d && d.deleted) {
                  sb.auth.signOut().then(function () {
                    showSignedIn(false);
                    if (dConfirm) dConfirm.hidden = true; if (dBtn) dBtn.hidden = false; dGo.disabled = false;
                    if (authmsg) authmsg.textContent = T("Your account and data have been permanently deleted.", "Ton compte et tes données ont été définitivement supprimés.");
                  });
                } else { dGo.disabled = false; if (dMsg) dMsg.textContent = T("Couldn't delete: ", "Échec : ") + ((d && d.error) || ""); }
              }).catch(function () { dGo.disabled = false; if (dMsg) dMsg.textContent = T("Something went wrong.", "Une erreur est survenue."); });
          });
        });
      }

      /* ---- cross-store Garage vehicles (shared vehicles table; TES writes it too) ----
         DB is the source of truth when signed in. Guest saves (localStorage) are adopted
         into the account on first signed-in page view; the local list is then mirrored
         from the DB so every store shows the same garage. epp.js emits epp:garage:add /
         remove / activate and renders from localStorage via window.EPPGarage. */
      var vsRows = [], vsMemberId = null, vsBusy = false;
      function vsNorm(x) { return String(x || "").toLowerCase().replace(/\s+/g, " ").trim(); }
      function vsLabel(v) {
        var composed = [v.year, v.make, v.model, v.trim, v.engine].filter(Boolean).join(" ");
        return composed || v.nickname || "";
      }
      function vsFind(label) {
        var n = vsNorm(label);
        for (var i = 0; i < vsRows.length; i++) if (vsNorm(vsLabel(vsRows[i])) === n) return vsRows[i];
        return null;
      }
      function vsMirror() {
        if (!window.EPPGarage) return;
        var ordered = vsRows.slice().sort(function (a, b) { return (a.created_at < b.created_at ? -1 : 1); });
        var active = null;
        ordered = ordered.filter(function (v) { if (v.is_active && !active) { active = v; return false; } return true; });
        if (active) ordered.push(active); // epp.js: active vehicle = last in the list
        window.EPPGarage.set(ordered.map(vsLabel).filter(Boolean));
      }
      function vsReload() {
        return sb.from("vehicles").select("*").then(function (r) { vsRows = r.data || []; vsMirror(); });
      }
      function vehicleSync(session) {
        if (vsBusy) return; vsBusy = true;
        sb.from("members").select("id").eq("auth_user_id", session.user.id).maybeSingle().then(function (r) {
          if (!r.data) { vsBusy = false; return; }
          vsMemberId = r.data.id;
          return sb.from("vehicles").select("*").then(function (vr) {
            vsRows = vr.data || [];
            // adopt guest-saved vehicles the account doesn't have yet.
            // ONLY labels with finder metadata qualify — meta marks "added on this
            // device, pending adoption". A bare label with no meta is a stale mirror
            // of the DB (e.g. the vehicle was removed on another store) and must NOT
            // be re-inserted; the DB is the source of truth for everything else.
            var local = (window.EPPGarage ? window.EPPGarage.get() : []);
            var meta = (window.EPPGarage ? window.EPPGarage.meta() : {});
            var missing = local.filter(function (L) { return !vsFind(L) && meta[L]; });
            var inserts = missing.map(function (L) {
              var m = meta[L];
              return { member_id: vsMemberId, year: m.year, make: m.make, model: m.model, engine: m.engine, is_active: false };
            });
            var p = inserts.length ? sb.from("vehicles").insert(inserts) : Promise.resolve();
            return p.then(function () {
              if (missing.length) { missing.forEach(function (L) { delete meta[L]; }); try { localStorage.setItem("epp_garage_meta", JSON.stringify(meta)); } catch (e) {} }
              return sb.from("vehicles").select("*").then(function (vr2) {
                vsRows = vr2.data || [];
                // no active vehicle anywhere yet → make the local active (last saved) the account's active
                if (vsRows.length && !vsRows.some(function (v) { return v.is_active; })) {
                  var lastLocal = local[local.length - 1], row = lastLocal && vsFind(lastLocal);
                  if (row) return sb.from("vehicles").update({ is_active: true }).eq("id", row.id).then(vsReload);
                }
                vsMirror();
              });
            });
          });
        }).then(function () { vsBusy = false; }).catch(function () { vsBusy = false; });
      }
      document.addEventListener("epp:garage:add", function (e) {
        sb.auth.getSession().then(function (r) {
          var sess = r.data && r.data.session; if (!sess || !vsMemberId) return;
          var L = e.detail.label; if (vsFind(L)) return;
          var meta = (window.EPPGarage ? window.EPPGarage.meta() : {})[L];
          var row = meta ? { member_id: vsMemberId, year: meta.year, make: meta.make, model: meta.model, engine: meta.engine }
                         : { member_id: vsMemberId, nickname: L };
          row.is_active = true; // newly saved vehicle becomes the active one (matches epp.js)
          sb.from("vehicles").update({ is_active: false }).eq("member_id", vsMemberId).then(function () {
            sb.from("vehicles").insert(row).then(function () {
              var meta2 = (window.EPPGarage ? window.EPPGarage.meta() : {});
              if (meta2[L]) { delete meta2[L]; try { localStorage.setItem("epp_garage_meta", JSON.stringify(meta2)); } catch (e) {} }
              vsReload();
            });
          });
        });
      });
      document.addEventListener("epp:garage:remove", function (e) {
        var row = vsFind(e.detail.label); if (!row) return;
        sb.from("vehicles").delete().eq("id", row.id).then(vsReload);
      });
      document.addEventListener("epp:garage:activate", function (e) {
        var row = vsFind(e.detail.label); if (!row || !vsMemberId) return;
        sb.from("vehicles").update({ is_active: false }).eq("member_id", vsMemberId).then(function () {
          sb.from("vehicles").update({ is_active: true }).eq("id", row.id).then(vsReload);
        });
      });

      sb.auth.onAuthStateChange(function (_evt, session) {
        loadMember();
        if (session && session.user) vehicleSync(session);
      });
      sb.auth.getSession().then(function (r) {
        var sess = r.data && r.data.session;
        if (sess && sess.user) vehicleSync(sess);
      });
      loadMember();
    });
  });
})();
